import React, { Component }         from 'react';

class Container extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    
    render() {
        let { children, full } = this.props;
        return (
            <div className={ `simprakit-modal${full ? ' full' : ''}` }>
                { children }
            </div>
        )
    }
}

export default Container;